import React from 'react';
import { useSelector } from 'react-redux';
import VerifyEmailForm from '../../components/VerifyEmailForm/VerifyEmailForm';
import ChangePasswordForm from '../../components/ChangePasswordForm/ChangePasswordForm';
import { Container } from 'reactstrap';
import { selectVerified } from 'src/redux/modules/memberReducer';

const VerifyAccount = () => {
  const isVerified = useSelector(selectVerified);

  return (
    <Container>
      {!isVerified && <VerifyEmailForm />}
      {isVerified && <ChangePasswordForm />}
    </Container>
  );
};

export default VerifyAccount;
